import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useQueryHelper, useSelectItem } from '@anytag/shared-hooks';
import { PricingTableItem, useCampaignCheckoutSessionLinkPromiseQuery } from '@anytag/graphql';
import { LinkRouterProps } from '@anytag/router';

const goBackUrl = '/tiktok/campaigns/add' as const satisfies LinkRouterProps['to'];

export const useSelectCampaignPlan = () => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { selectedItem, setSelectedItem } = useSelectItem<PricingTableItem['id']>();
  const { getCampaignCheckoutSessionLink } = useCampaignCheckoutSessionLinkPromiseQuery();

  const handleSelectPlan = async (priceId: number | null, packageId: number | null) => {
    if (!priceId || !packageId) return;

    try {
      setSelectedItem(priceId);
      const { data } = await getCampaignCheckoutSessionLink({
        variables: {
          priceId,
          packageId,
          redirectUrl: `${window.location.origin}${goBackUrl}?priceId=${priceId}&packageId=${packageId}&sessionId={CHECKOUT_SESSION_ID}`
        }
      });
      const planUrl = data.campaignCheckoutSessionLink?.url;

      if (planUrl) {
        window.location.href = planUrl;
      }
    } catch (error) {
      enqueueSnackbar(t(error?.message || UNEXPECTED_ERROR), { variant: 'error' });
    } finally {
      setSelectedItem(null);
    }
  };

  return {
    handleSelectPlan,
    selectedPlanId: selectedItem
  };
};
